<template>
  <div class="card-links-container">
    <div class="card-link-container" v-for="link in links" :key="link">
      <a class="card-link" :href="link" target="_blank" rel="noopener noreferrer">{{ link }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "CardLinks",
  props: ["text"],
  computed: {
    links() {
      if (!this.text) return [];

      const links = [];
      const urlPattern = /(http|https):\/\/\S+/g;
      const match = this.text.match(urlPattern);
      if (match) {
        match.forEach(m => links.push(m));
      }

      return links;
    }
  },
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="postcss">
.card-links-container {
  overflow-x: hidden;
  font-size: 0.9em;
  .card-link-container {
    .card-link {
      display: inline-block;
      text-overflow: ellipsis;
      width: 100%;
      overflow: hidden;
    }
  }
}
</style>
